import React, { useState, useEffect } from "react";
import api from "../../axios/api";
import "../../assets/NewFiles/Css/Dashboard.css";
import { ToastContainer } from "react-toastify";
import { Box, Typography } from "@mui/material";
import BulkUserModal from "./BulkUserModal";
import AddIcon from "@mui/icons-material/Add";
import Loader from "../common/Loader";
import Button from "../common/styled components/Button";
import Grid from "../common/Grid";
import { PlusIcon } from "lucide-react";

const EmployeeTable = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const rowsPerPage = 10;
  const [isBulkUserModalOpen, setIsBulkUserModalOpen] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      setIsLoading(true);
      try {
        const response = await api.get("/api/user/getemployees");
        setUsers(response.data || []);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const filteredUsers = users.filter(
    (user) => user.role_code !== "admin" && user.role_code !== "superadmin"
  );

  const columns = [
    {
      header: "Full Name",
      accessor: "full_name",
      sortable: true,
    },
    {
      header: "Email",
      accessor: "userEmail",
      sortable: true,
    },
    {
      header: "Total Trees",
      accessor: "totalTrees",
      sortable: true,
      align: "center",
      render: (val) => val ?? 0,
    },
    {
      header: "Verified Trees",
      accessor: "verifiedTrees",
      sortable: true,
      align: "center",
      render: (val) => val ?? 0,
    },
    {
      header: "Last Login",
      accessor: "lastLogin",
      sortable: true,
      align: "center",
      render: (val) => (val ? new Date(val).toLocaleString() : "-"),
    },
  ];

  return (
    <div>
      <Box sx={{ width: "100%", margin: "auto", padding: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box
              sx={{
                width: 4,
                height: 28,
                bgcolor: "#10b981",
                borderRadius: "4px",
                flexShrink: 0,
              }}
            />
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontFamily: "'Plus Jakarta Sans', 'Outfit', 'Inter', sans-serif",
                fontSize: { xs: "1.4rem", sm: "1.75rem" },
                fontWeight: 700,
                color: "#002F43",
                letterSpacing: "-0.02em",
                m: 0,
                lineHeight: 1.2,
              }}
            >
              Employee Management
            </Typography>
          </Box>

          <Button
            startIcon={<AddIcon />}
            onClick={() => setIsBulkUserModalOpen(true)}
          >
            <PlusIcon size={18} className="mr-2" />
            Create Multiple Users
          </Button>
        </Box>
        <BulkUserModal
          open={isBulkUserModalOpen}
          onClose={() => setIsBulkUserModalOpen(false)}
        />
        <ToastContainer />
        {isLoading && (
          <div
            className="loading-overlay"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 1000,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loader />
          </div>
        )}
        <div
          className={isLoading ? "content-disabled" : ""}
          style={{
            pointerEvents: isLoading ? "none" : "auto",
            opacity: isLoading ? 0.6 : 1,
            transition: "opacity 0.3s",
          }}
        >
          <Box sx={{ padding: 2 }}>
            <Grid
              columns={columns}
              data={filteredUsers}
              loading={isLoading}
              variant="navy"
              pagination={true}
              pageSize={rowsPerPage}
              pageSizeOptions={[5, 10, 20, 50]}
              rowKey="id"
              emptyMessage="No employees found"
            />
          </Box>
        </div>
      </Box>
    </div>
  );
};

export default EmployeeTable;
